import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect } from "react";
import { HeaderDesktopContent } from "@faire/retailer/components/Header/desktop/HeaderDesktopContent";
import { NavigationLinksBar } from "@faire/retailer/components/Header/desktop/NavigationLinksBar/NavigationLinksBar";
import { HeaderContainer } from "@faire/retailer/components/Header/styled";
import { useIsSemDiscoverPage } from "@faire/retailer/lib/useIsSemDiscoverPage";
import { useAssignSettingHeaderNavSignupCTACopy } from "@faire/retailer/settings/useSettingHeaderNavSignupCTACopy";
export var HeaderDesktop = function(param) {
    var className = param.className;
    var isSemDiscoverPage = useIsSemDiscoverPage();
    var assignSettingHeaderNavSignupCTACopy = useAssignSettingHeaderNavSignupCTACopy();
    useEffect(function() {
        assignSettingHeaderNavSignupCTACopy();
    }, [
        assignSettingHeaderNavSignupCTACopy
    ]);
    return /*#__PURE__*/ _jsxs(HeaderContainer, {
        className: className,
        children: [
            /*#__PURE__*/ _jsx(HeaderDesktopContent, {}),
            isSemDiscoverPage ? null : /*#__PURE__*/ _jsx(NavigationLinksBar, {})
        ]
    });
};
